import type { ScreenSchema } from './types';

/**
 * Schema for the `image-list` template.
 *
 * The template renders uc-content (heading, text, instructions) via
 * +template-wrapper, followed by a loop over `screen.items[]` where each
 * item displays `item.img` (visual) and `item.text` (audible caption).
 *
 * The InlineIteratedPart folds all item captions into the single intro slot
 * so they are narrated as a continuous sequence after the main content.
 */
const imageListSchema: ScreenSchema = {
  template: 'image-list',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        {
          iterateField: 'items',
          parts: [{ field: 'text' }]
        }
      ]
    }
  }
};

export default imageListSchema;
